import { Component, Injector, OnInit, inject } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { PageKind, entityState, UiModeType, } from 'jk-service';
import { StkleService, templateUrlConfigStk } from './../_service_stk';
import { StkleEditComponent, } from './../_edit_stk';
import { AdvComModule, jkSingleComponent, } from 'jk-advcom';


@Component({
  selector: 'app-stkpi20',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: templateUrlConfigStk.stkpi20,
  styleUrls: [],
})
export class Stkpi20Component extends jkSingleComponent implements OnInit {
  override _programId = 'stkpi20';
  constructor() {
    super();
    this.srv = new StkleService();
    this.uiMode = UiModeType.dialog;
    this.title = '股票通知訊息建立';
    this.gridInitOpt = { programId: this.programId, sortField: 'LE001', sort: 'desc', defaultSort: null, pageKind: PageKind.master };
    this.qbeConfig.addField = 'LE003,LE006,LE004,LE007,LE010';
    this.qbeConfig.addWhere = 'LE003,LE006,LE004,LE007,LE010';
    this.masterEditPage = StkleEditComponent;


    this.constructorInit();
  }

  /*
  override getLookup() {
    super.getLookup();
  }

  override constructorInit() {
    super.constructorInit();
  }
  */


}
